import Vue from 'vue';
import store  from '@/store/index';
Vue.filter('theme', function (value) {
    if (!value) return '';
    let item = store.getters.menu.themes.find( f=> f.key == value);
    if(item) return item.value;
    return '';
});